import { render, staticRenderFns } from "./ReportIssue.vue?vue&type=template&id=1996c1d1&scoped=true&"
import script from "./ReportIssue.vue?vue&type=script&lang=js&"
export * from "./ReportIssue.vue?vue&type=script&lang=js&"
import style0 from "./ReportIssue.vue?vue&type=style&index=0&id=1996c1d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1996c1d1",
  null
  
)

export default component.exports